export default "__VITE_ASSET__Bme_6wKX__"